import './App.css';
import React from "react";
import HomePage from "./pages/HomePage";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import ShopPage from "./pages/ShopPage";
import EducationPage from "./pages/EducationPage";
import ProjectsPage from "./pages/ProjectsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import Footer from "./components/Footer";
import SidebarOne from "./components/SidebarOne";

function App() {
  return (
    <div className="layout">
        <BrowserRouter>
            <SidebarOne />
            <div className="main">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/projects" element={<ProjectsPage />} />
                    <Route path="/shop" element={<ShopPage />} />
                    <Route path="/education" element={<EducationPage />} />
                    <Route path="/tools" element={<ProjectsPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                </Routes>
                <div className="">
                    <Footer />
                </div>
            </div>

        </BrowserRouter>
    </div>
  );
}

export default App;
